import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "signin-container" }
const _hoisted_3 = {
  key: 0,
  class: "branding"
}
const _hoisted_4 = { class: "logo logo--lg" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "detail" }
const _hoisted_7 = { class: "button-container" }
const _hoisted_8 = { class: "return" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ShadowContainer = _resolveComponent("ShadowContainer")!
  const _component_unauthenticated_layout = _resolveComponent("unauthenticated-layout")!

  return (_openBlock(), _createBlock(_component_unauthenticated_layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.logoUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, [
                  _createElementVNode("img", {
                    class: "icon",
                    src: _ctx.logoUrl,
                    alt: ""
                  }, null, 8, _hoisted_5)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_ShadowContainer, null, {
            default: _withCtx(() => [
              _createElementVNode("h4", null, [
                _createVNode(_component_TranslatedText, { path: "auth.forgotten-password-header" })
              ]),
              _createElementVNode("p", _hoisted_6, [
                _createVNode(_component_TranslatedText, { path: "auth.send-recovery" })
              ]),
              _createVNode(_component_Form, {
                modelValue: _ctx.model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
                errors: _ctx.errors,
                "onUpdate:errors": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.errors) = $event)),
                schema: _ctx.rules
              }, {
                default: _withCtx(({ handleInputChange, isValid }) => [
                  _createVNode(_component_FormInput, {
                    customClass: "light icon email",
                    id: "email",
                    name: "email",
                    type: "email",
                    label: "form.email-address",
                    value: _ctx.model.email,
                    error: _ctx.errors['email'],
                    onChange: handleInputChange,
                    onEnter: _ctx.handleSubmit,
                    required: ""
                  }, null, 8, ["value", "error", "onChange", "onEnter"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Button, {
                      variant: _ctx.getVariant,
                      text: "auth.send-recovery-link",
                      disabled: !isValid || (isValid && _ctx.buttonDisabled),
                      onClick: _ctx.handleSubmit,
                      block: ""
                    }, null, 8, ["variant", "disabled", "onClick"])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "errors", "schema"]),
              _createElementVNode("p", _hoisted_8, [
                _createVNode(_component_TranslatedText, { path: "auth.remembered-password" }),
                _cache[2] || (_cache[2] = _createTextVNode("  ", -1)),
                _createVNode(_component_router_link, { to: "/signin" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_TranslatedText, { path: "auth.sign-in" })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}